import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=f66e415a&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=f66e415a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66e415a",
  null
  
)

export default component.exports